import React from 'react';
import { ToastProvider } from '../ToastContext';
import { ConfirmationDialogProvider } from '../ConfirmationDialog';
import TinyBaseProvider from '@/context/TinyBaseProvider/TinyBaseProvider';
import { Outlet } from 'react-router';
import ZopimChat from '@/components/ZopimChat';
import { useFavicon } from '@/hooks/useFavicon';

/**
 * @name GlobalContext
 * @description Wrapper component for all global context providers except MUI and Error Boundary
 * @param children
 * @constructor
 */
const GlobalContext: React.FC<unknown> = () => {
    useFavicon('/favicon-32x32.png');
    return (
        <TinyBaseProvider>
            <ConfirmationDialogProvider>
                <ToastProvider>
                    <ZopimChat />
                    <Outlet />
                </ToastProvider>
            </ConfirmationDialogProvider>
        </TinyBaseProvider>
    );
};

export default GlobalContext;
